import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';

//gets sessionid props from MarketOrders

//this component checks (StartSim/ready)
//and conditionally renders the start
//button accordingly

class ButtonTutorial extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isPaused: true,
      ready: true,
      canStart: true
    }
    this.start = this.start.bind(this);
    this.pause = this.pause.bind(this);
  }

  //deals with starting and restarting a session
  start() {
    const simStateRef = firebase.database().ref().child("Session2").child('StartSim');
    simStateRef.child("start").set(true);
    simStateRef.child("State").set("Running");
    this.setState({
      isPaused: false
    })
    //console.log("true");
  }

  //deals with pausing a session
  pause() {
    const simStateRef = firebase.database().ref().child("Session2").child('StartSim');
    this.setState({
      isPaused: true
    })
    //console.log("Changing state of running to 'Paused'");
    simStateRef.child("running").remove().then(function() {
      simStateRef.child("start").set(false);
    }).then(function() {
      simStateRef.child("State").set("Paused");
    });
  }

  componentDidMount() {
    //console.log(this.props);

    this.creatorRef = firebase.database().ref().child(this.props.institution).child("PlayableSessions").child("-KsPO8oZeAaOvOje8yzJ").child("Creator");
    this.creatorRef.once("value").then( snap => {
      if(this.props.uid === snap.val()){
        //console.log(this.props.uid, snap.val())
        this.setState({
          canStart: true
        })
      }else{
        this.setState({
          canStart: false
        })
      }
    })

    this.buttonStateRef = firebase.database().ref().child("Session2").child('StartSim').child('Ready');
    this.buttonStateRef.on('value', snap => {
      if (snap.val()) {
        this.setState({
          isPaused: true,
          ready: true
        })
      }
    })


  }

  componentWillUnmount() {
    this.buttonStateRef.off();
    //console.log("Unmounting");
    this.setState({
      isPaused: false,
      ready: true
    });
  }

  render() {
    // const isPaused = this.state.isPaused;
    // let button = null;
    // if (true) {
    //   button = <button onClick={this.start} className="btn btn-danger start">Start</button>;
    // } else {
    //   button = <div></div> //<button onClick={this.pause} className="btn btn-danger pause">Pause</button>;
    // }

    return (
      <div className="col-xs-4">
        <button disabled={true} className="btn btn-danger start">Start</button>
      </div>
    );
  }
}

ButtonTutorial.propTypes = {
  sessionid: PropTypes.string
};

export default ButtonTutorial;



// WEBPACK FOOTER //
// ./src/components/OrderbookTutorial/ButtonsTutorial.js